import { useTheme } from "../context/ThemeContext";

const FilterIcon = ({onClick}) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} role="button">
    <path d="M1.5 8.625C1.5 5.26624 1.5 3.58686 2.54343 2.54343C3.58686 1.5 5.26624 1.5 8.625 1.5C11.9838 1.5 13.6631 1.5 14.7066 2.54343C15.75 3.58686 15.75 5.26624 15.75 8.625C15.75 11.9838 15.75 13.6631 14.7066 14.7066C13.6631 15.75 11.9838 15.75 8.625 15.75C5.26624 15.75 3.58686 15.75 2.54343 14.7066C1.5 13.6631 1.5 11.9838 1.5 8.625Z" stroke="white" stroke-width="1.5"/>
    <path d="M6.375 8.625L10.8751 8.62504" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.125 11.25H10.125" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.625 6H11.625" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default FilterIcon;
